import type { NuxtApp } from "#app";

export { apiBool, unwrapList } from "@carnet/api/runtime";

// getCachedData « SWR » : sert le cache à l'hydration et aux navigations, mais
// laisse les refresh (refreshNuxtData/refresh) re-fetcher — renvoyer undefined
// force le réseau sans vider data, donc swap silencieux à la résolution.
export function cachedDataUnlessRefresh(key: string, nuxtApp: NuxtApp, ctx: { cause: string }) {
  if (ctx.cause === "refresh:hook" || ctx.cause === "refresh:manual") return undefined;
  return nuxtApp.payload.data[key] ?? nuxtApp.static.data[key];
}

export function throwOnNotFound(error: unknown, statusMessage: string): void {
  const err = error as { statusCode?: number; status?: number } | null | undefined;
  const statusCode = err?.statusCode ?? err?.status;
  if (statusCode === 404) {
    throw createError({ statusCode: 404, statusMessage, fatal: true });
  }
}
